import React, { useState } from 'react';
interface Tab {
  id: string;
  label: string;
  content: React.ReactNode;
  disabled?: boolean;
}
interface TabsProps {
  tabs: Tab[];
  defaultTab?: string;
  orientation?: 'horizontal' | 'vertical';
  variant?: 'default' | 'pills' | 'underlined';
  className?: string;
  tabClassName?: string;
  contentClassName?: string;
  onChange?: (tabId: string) => void;
}
const Tabs: React.FC<TabsProps> = ({
  tabs,
  defaultTab,
  orientation = 'horizontal',
  variant = 'default',
  className = '',
  tabClassName = '',
  contentClassName = '',
  onChange
}) => {
  const [activeTab, setActiveTab] = useState<string>(defaultTab || (tabs.length > 0 ? tabs[0].id : ''));
  const handleTabClick = (tabId: string) => {
    setActiveTab(tabId);
    if (onChange) {
      onChange(tabId);
    }
  };
  const getTabStyles = (tab: Tab, isActive: boolean) => {
    const baseStyles = 'px-4 py-2 text-sm font-medium focus:outline-none';
    const disabledStyles = tab.disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer';
    if (variant === 'pills') {
      return `${baseStyles} ${isActive ? 'bg-navy-900 text-white rounded-md' : 'text-ink-500 hover:text-ink-700 hover:bg-ink-100 rounded-md'} ${disabledStyles} ${tabClassName}`;
    } else if (variant === 'underlined') {
      return `${baseStyles} ${isActive ? 'text-navy-900 border-b-2 border-navy-900' : 'text-ink-500 hover:text-ink-700 hover:border-ink-300 border-b-2 border-transparent'} ${disabledStyles} ${tabClassName}`;
    } else {
      // default variant
      return `${baseStyles} ${isActive ? 'bg-white text-ink-900 rounded-t-md border-l border-r border-t' : 'text-ink-500 hover:text-ink-700 hover:bg-ink-50'} ${disabledStyles} ${tabClassName}`;
    }
  };
  return <div className={`${orientation === 'vertical' ? 'flex flex-row' : ''} ${className}`}>
      <div className={`${orientation === 'vertical' ? 'flex flex-col border-r' : variant === 'default' ? 'flex border-b' : 'flex'}`}>
        {tabs.map(tab => <button key={tab.id} className={getTabStyles(tab, activeTab === tab.id)} onClick={() => !tab.disabled && handleTabClick(tab.id)} disabled={tab.disabled} role="tab" aria-selected={activeTab === tab.id} aria-controls={`panel-${tab.id}`}>
            {tab.label}
          </button>)}
      </div>
      <div className={`${orientation === 'vertical' ? 'flex-1 p-4' : 'pt-4'} ${contentClassName}`}>
        {tabs.map(tab => <div key={tab.id} id={`panel-${tab.id}`} role="tabpanel" aria-labelledby={tab.id} className={activeTab === tab.id ? 'block' : 'hidden'}>
            {tab.content}
          </div>)}
      </div>
    </div>;
};
export default Tabs;